import { useAtomValue } from 'jotai';
import { Routes } from 'src/Routes.constants';
import {
  tariffSummaryFiltersAtom,
  tariffSummarySortingAtomWithStorage,
} from 'src/atoms/filters/tariff-summary';
import { combinedTariffSummaryFiltersAndSortingMapper } from 'src/atoms/filters/utils/filterMappers';

export const useTariffSummaryUrlFromFilters = () => {
  const filters = useAtomValue(tariffSummaryFiltersAtom);
  const sorting = useAtomValue(tariffSummarySortingAtomWithStorage);

  return `${Routes.tariffSummary}?${combinedTariffSummaryFiltersAndSortingMapper(
    filters,
    sorting,
  )}`;
};
